export default __webpack_public_path__ + "static/media/pinterest.7ae5c089.svg";